import { DEFAULT_CONFIG } from '@src/utils/x-ani';

export const X_ANI_CONFIG = {
  step1: {
    ...DEFAULT_CONFIG,
    y: -100,
    opacity: 0
  },
  step2: {
    ...DEFAULT_CONFIG,
    y: -100,
    opacity: 0
  },
  step3: {
    ...DEFAULT_CONFIG,
    y: -100,
    opacity: 0
  }
};
